import * as React from 'react';
import * as styleSheet from '../styles';
import { Box } from '@enaep-ng/benchmark';
import { FrameProps } from '../types';

/// rename to container
const FrameBottom = ({ customStyle }: FrameProps) => {
  return <Box sx={styleSheet.frameStyledBottom} style={customStyle} />;
};
const FrameTop = ({ children, customStyle }: FrameProps) => {
  return (
    <Box sx={styleSheet.frameStyledTop} style={customStyle}>
      {children}
    </Box>
  );
};

const FrameBody = ({ children, customStyle }: FrameProps) => {
  return <Box sx={styleSheet.frameStyleBody} style={customStyle}>{children}</Box>;
};
export { FrameBottom, FrameTop, FrameBody };
